module.exports = __webpack_public_path__ + "img/6_158.62dfc0c8.png";